// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_withdrawRentalNeed(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["RentalNeedWithdrawn"]);
}

let variablesConverter = {"withdrawRentalNeedInput":{},"__root":{"input":{"r":"withdrawRentalNeedInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"withdrawRentalNeed_RentalNeedWithdrawn_rentalNeed":{"f":""},"withdrawRentalNeed":{"u":"response_withdrawRentalNeed"}}};

let wrapResponseConverterMap = {
  response_withdrawRentalNeed: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"withdrawRentalNeed_RentalNeedWithdrawn_rentalNeed":{"f":""},"withdrawRentalNeed":{"u":"response_withdrawRentalNeed"}}};

let responseConverterMap = {
  response_withdrawRentalNeed: unwrap_response_withdrawRentalNeed
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusChangeComment",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WithdrawRentalNeedDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "withdrawRentalNeed",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RentalNeedV5",
                "kind": "LinkedField",
                "name": "rentalNeed",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "RenterPageHeader_StatusChangeButton_rentalNeedV5"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "RenterPageStatusCallout_rentalNeedV5"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ClientPageMatchingStatusLabel_matchable"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "RentalNeedWithdrawn",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WithdrawRentalNeedDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "withdrawRentalNeed",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RentalNeedV5",
                "kind": "LinkedField",
                "name": "rentalNeed",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isRenewable",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "activeUntil",
                            "storageKey": null
                          }
                        ],
                        "type": "ActiveRentalNeed",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expiredAt",
                            "storageKey": null
                          }
                        ],
                        "type": "ExpiredRentalNeed",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "withdrawnAt",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "type": "WithdrawnRentalNeed",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "statusChangedAt",
                            "storageKey": null
                          }
                        ],
                        "type": "RentedRentalNeed",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "activelyMatching",
                        "storageKey": null
                      }
                    ],
                    "type": "Matchable",
                    "abstractKey": "__isMatchable"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "RentalNeedWithdrawn",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f78aa9e9982cfc7e431bd394d4d6698e",
    "id": null,
    "metadata": {},
    "name": "WithdrawRentalNeedDialogMutation",
    "operationKind": "mutation",
    "text": "mutation WithdrawRentalNeedDialogMutation(\n  $input: WithdrawRentalNeedInput!\n) {\n  withdrawRentalNeed(input: $input) {\n    __typename\n    ... on RentalNeedWithdrawn {\n      rentalNeed {\n        ...RenterPageHeader_StatusChangeButton_rentalNeedV5\n        ...RenterPageStatusCallout_rentalNeedV5\n        ...ClientPageMatchingStatusLabel_matchable\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ClientPageMatchingStatusLabel_matchable on Matchable {\n  __isMatchable: __typename\n  __typename\n  activelyMatching\n}\n\nfragment ExpiredRentalNeedCallout_expiredRentalNeed on ExpiredRentalNeed {\n  expiredAt\n}\n\nfragment ExpiringRentalNeedCallout_activeRentalNeed on ActiveRentalNeed {\n  activeUntil\n}\n\nfragment RentedRentalNeedCallout_rentedRentalNeed on RentedRentalNeed {\n  statusChangeComment\n  statusChangedAt\n}\n\nfragment RenterPageHeader_StatusChangeButton_rentalNeedV5 on RentalNeedV5 {\n  nodeId\n  status {\n    __typename\n    ... on ActiveRentalNeed {\n      isRenewable\n    }\n    ... on ExpiredRentalNeed {\n      __typename\n    }\n    ... on WithdrawnRentalNeed {\n      __typename\n    }\n    ... on RentedRentalNeed {\n      __typename\n    }\n  }\n}\n\nfragment RenterPageStatusCallout_rentalNeedV5 on RentalNeedV5 {\n  nodeId\n  status {\n    __typename\n    ... on ActiveRentalNeed {\n      isRenewable\n      ...ExpiringRentalNeedCallout_activeRentalNeed\n    }\n    ... on ExpiredRentalNeed {\n      ...ExpiredRentalNeedCallout_expiredRentalNeed\n    }\n    ... on WithdrawnRentalNeed {\n      ...WithdrawnRentalNeedCallout_withdrawnRentalNeed\n    }\n    ... on RentedRentalNeed {\n      ...RentedRentalNeedCallout_rentedRentalNeed\n    }\n  }\n}\n\nfragment WithdrawnRentalNeedCallout_withdrawnRentalNeed on WithdrawnRentalNeed {\n  withdrawnAt\n  statusChangeComment\n}\n"
  }
};
})());

let wrap_response_withdrawRentalNeed = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_withdrawRentalNeed = unwrap_response_withdrawRentalNeed;
exports.wrap_response_withdrawRentalNeed = wrap_response_withdrawRentalNeed;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
